export { ProductMediaCarousel } from './ProductMediaCarousel';
